<script>
	export let id;
	export let section;
	export let component;
	export let color;
	export let height;
	export let minHeight;
	export let maxHeight;
	export let backgroundFixed;
	export let width;
	export let maxWidth;
	export let current;
	export let slideProgress;
	export let past;
</script>

<section
	id="{section}_{id}"
	style:height
	style:min-height={minHeight}
	style:max-height={maxHeight}
	style:background={backgroundFixed}
	class:current
	class:past
>
	<div class="content t-{color || 'black'}" style:width style:max-width={maxWidth}>
		<svelte:component this={component} {...$$props} />
	</div>
</section>

<style lang="scss">
	.content {
		position: relative;
		max-width: 1200px;
		height: 100%;
		margin: 0 auto;
		width: calc(100% - 80px);
		box-sizing: border-box;

		@media (max-width: $breakpoint-tablet) {
			width: calc(100% - 60px);
		}

		@media (max-width: $breakpoint-mobile) {
			width: calc(100% - 30px);
		}
	}

	section :global(.text) {
		opacity: 0;
		transform: translateY(30px);
		transition: opacity 0.7s ease-in-out, transform 0.5s ease-out;
	}

	section.current :global(.text) {
		transform: translateY(0);
		opacity: 1;
	}

	section :global(.text .coop) {
		transform: translateY(-60px);
		transition: opacity 0.7s ease-in-out, transform 0.5s ease-out;
	}

	section.current :global(.text .coop) {
		transform: translateY(0);
	}

	section :global(.anim-css-c .animatable-css-inner > div) {
		transform: translateY(0);
		opacity: 1;
		transition: opacity 0.3s ease-in-out, transform 1s ease-out;
	}

	section :global(.anim-css-c > div:nth-child(1) .animatable-css-inner > div) {
		transition: opacity 0.3s 0.2s ease-in-out, transform 1s ease-out;
	}

	section :global(.anim-css-c > div:nth-child(2).animatable-css-inner > div) {
		transition: opacity 0.3s 0.3s ease-in-out, transform 1s 0.1s ease-out;
	}

	section :global(.anim-css-c > div:nth-child(3) .animatable-css-inner > div) {
		transition: opacity 0.3s 0.4s ease-in-out, transform 1s 0.2s ease-out;
	}

	section :global(.anim-css-c > div:nth-child(4) .animatable-css-inner > div) {
		transition: opacity 0.3s 0.5s ease-in-out, transform 1s 0.3s ease-out;
	}

	section.past :global(.anim-css-c .animatable-css-inner > div) {
		opacity: 0;
		transform: translateY(-200px);
	}

	section.current :global(.anim-css-c .animatable-css-inner > div) {
		opacity: 1;
		transform: translateY(0);
		// transition: none;
	}

	section#chefs_chefs :global(.anim-css-c .animatable-css-inner > div) {
		opacity: 1 !important;
		transform: none !important;
		transition: none !important;
	}

	section#fragen_experten {
		@media (max-width: $breakpoint-tablet) {
			height: 130vw;
			max-height: unset;
		}
		@media (min-width: #{$breakpoint-mobile + 1px}) and (max-width: $breakpoint-tablet) {
			height: calc(500px + 100vw);
			min-height: unset;
			max-height: unset;
		}
		@media (max-width: $breakpoint-mobile) {
			height: 100vh !important;
			min-height: 800px;
			max-height: 1000px;
		}
	}

	section#fragen_information {
		@media (min-width: #{$breakpoint-mobile + 1px}) and (max-width: $breakpoint-tablet) {
			height: calc(500px + 50vw);
			min-height: unset;
			max-height: unset;
		}
		@media (max-width: $breakpoint-mobile) {
			height: 100vh !important;
			min-height: 800px;
			max-height: 1000px;
		}
	}

	section#fragen_berlin {
		@media (max-width: $breakpoint-tablet) and (max-width: $breakpoint-tablet) {
			height: 130vw !important;
			max-height: unset !important;
		}
		@media (max-width: $breakpoint-mobile) {
			height: 110vh !important;
			min-height: 900px;
			max-height: 1050px;
		}
	}

	section#fragen_international {
		@media (min-width: #{$breakpoint-mobile + 1px}) and (max-width: $breakpoint-tablet) {
			height: 120vw !important;
			max-height: unset !important;
		}
		@media (max-width: $breakpoint-mobile) {
			height: 110vh !important;
			min-height: 820px;
			max-height: 1000px;
		}
	}

	section#produkt_zwei_in_einer {
		@media (min-width: #{$breakpoint-mobile + 1px}) and (max-width: $breakpoint-tablet) {
			height: calc(450px + 70vw * 1.425);
			min-height: unset;
			max-height: 960px;
		}

		@media (max-width: $breakpoint-mobile) {
			max-height: none;
			height: 100vh;
			min-height: 850px;
		}
	}

	section#produkt_national_mehr_politik {
		@media (min-width: #{$breakpoint-tablet + 1px}) {
			min-height: 1000px;
		}
		@media (min-width: #{$breakpoint-mobile + 1px}) and (max-width: $breakpoint-tablet) {
			height: calc(750px + 140vw / 1.425);
			min-height: unset;
			max-height: unset;
		}

		@media (max-width: $breakpoint-mobile) {
			min-height: 910px;
			max-height: unset;
		}
	}

	section#produkt_national_fachredaktionen {
		@media (min-width: #{$breakpoint-tablet + 1px}) {
			min-height: 1000px;
		}

		@media (min-width: #{$breakpoint-mobile + 1px}) and (max-width: $breakpoint-tablet) {
			height: calc(600px + 100vw / 1.425);
			min-height: unset;
			max-height: unset;
		}
		@media (max-width: $breakpoint-mobile) {
			min-height: 750px;
			max-height: 800px;
			height: 100vh;
		}
	}

	section#produkt_national_kultur {
		@media (min-width: #{$breakpoint-mobile + 1px}) and (max-width: $breakpoint-tablet) {
			height: calc(450px + 140vw / 1.425);
			min-height: unset;
			max-height: unset;
		}
		@media (max-width: $breakpoint-mobile) {
			min-height: 880px;
			max-height: 1000px;
			height: 200vw;
		}
	}

	section#produkt_national_ausblick {
		@media (min-width: #{$breakpoint-tablet + 1px}) {
			min-height: 1000px;
		}
		@media (min-width: #{$breakpoint-mobile + 1px}) and (max-width: $breakpoint-tablet) {
			height: calc(550px + 60vw * 1.425);
			min-height: unset;
			max-height: unset;
		}
		@media (max-width: $breakpoint-mobile) {
			min-height: 870px;
			max-height: unset;
		}
	}

	section#produkt_wochenende_wochenende {
		@media (min-width: #{$breakpoint-mobile + 1px}) and (max-width: $breakpoint-tablet) {
			height: calc(700px + 100vw / 1.425 + 50px);
			min-height: unset;
			max-height: unset;
		}

		@media (max-width: $breakpoint-mobile) {
			min-height: 930px;
		}
	}

	section#produkt_wochenende_sonntag {
		@media (min-width: #{$breakpoint-mobile + 1px}) and (max-width: $breakpoint-tablet) {
			height: calc(400px + 140vw / 1.425);
			min-height: unset;
			max-height: unset;
		}

		@media (max-width: $breakpoint-mobile) {
			min-height: 930px;
			max-height: 1200px;
			height: 200vw;
		}
	}

	section#produkt_berlin_umland {
		@media (min-width: #{$breakpoint-mobile + 1px}) and (max-width: $breakpoint-tablet) {
			height: calc(450px + 100vw / 1.425 + 50px);
			min-height: unset;
			max-height: unset;
		}
		@media (max-width: $breakpoint-mobile) {
			min-height: 830px;
			max-height: none;
			height: 100vh;
		}
	}

	section#produkt_berlin_bezirke {
		@media (min-width: #{$breakpoint-mobile + 1px}) and (max-width: $breakpoint-tablet) {
			height: calc(520px + 70vw / 1.425 + 250px);
			min-height: unset;
			max-height: unset;
		}

		@media (max-width: $breakpoint-mobile) {
			min-height: 850px;
			max-height: none;
			height: 100vh;
		}
	}

	section#produkt_berlin_politik {
		@media (min-width: #{$breakpoint-mobile + 1px}) and (max-width: $breakpoint-tablet) {
			height: calc(500px + 140vw / 1.425);
			min-height: unset;
			max-height: unset;
		}

		@media (max-width: $breakpoint-mobile) {
			min-height: 930px;
			max-height: 1200px;
			height: 200vw;
		}
	}

	section#produkt_berlin_wissenschaft_wirtschaft {
		@media (min-width: #{$breakpoint-mobile + 1px}) and (max-width: $breakpoint-tablet) {
			height: calc(450px + 180vw / 1.425 + 50px);
			min-height: unset;
			max-height: unset;
		}

		@media (max-width: $breakpoint-mobile) {
			min-height: 1050px;
			max-height: unset;
		}
	}

	section#produkt_national_interviews {
		@media (min-width: #{$breakpoint-tablet + 1px}) {
			min-height: unset;
			max-height: unset;
			height: 1420px;
		}

		@media (min-width: #{$breakpoint-mobile + 1px}) and (max-width: $breakpoint-tablet) {
			height: calc(450px + 100vw / 1.425);
			min-height: unset;
			max-height: unset;
		}
		@media (max-width: $breakpoint-mobile) {
			min-height: 650px;
			max-height: 700px;
		}
	}

	section#produkt_berlin_tagestipps {
		@media (min-width: #{$breakpoint-mobile + 1px}) and (max-width: $breakpoint-tablet) {
			height: calc(450px + 160vw / 1.425 + 30px);
			min-height: unset;
			max-height: unset;
		}

		@media (max-width: $breakpoint-mobile) {
			min-height: calc(100vw + 550px);
			max-height: unset;
		}
	}

	section#produkt_wochenende_genuss {
		@media (min-width: #{$breakpoint-tablet + 1px}) {
			min-height: unset;
			max-height: unset;
			height: 1500px;
		}

		@media (min-width: #{$breakpoint-mobile + 1px}) and (max-width: $breakpoint-tablet) {
			height: calc(550px + 100vw / 1.425);
			min-height: unset;
			max-height: unset;
		}

		@media (max-width: $breakpoint-mobile) {
			height: 100vh;
			min-height: 765px;
			max-height: 760px;
		}
	}

	section#abo_print {
		@media (min-width: #{$breakpoint-tablet + 1px}) {
			min-height: unset;
		}
	}

	section#chefs_chefs {
		min-height: 1015px;

		@media (max-width: $breakpoint-tablet) {
			max-height: 1030px;
		}

		@media (max-width: $breakpoint-mobile) {
			min-height: 700px;
			max-height: 730px;
		}
	}
</style>
